/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef } from "react";
import Content from "../../../../layout/content/Content";
import {
    Spinner, Modal,
    ModalBody,
    ModalFooter
} from "reactstrap";
import loadspinner from "../../../../assets/images/spinner.gif"
import {
    Button,
    Block,
    Row,
    Col,
    Icon,
    BlockDes,
    BlockHead, PaginationComponent
} from "../../../../components/Component";
import Head from "../../../../layout/head/Head";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionS from "../../../components/DynmicOption/OptionS";
import OptionC from "../../../components/DynmicOption/OptionC";
import OptionM from "../../../components/DynmicOption/OptionM"; 


const ES1DataReport = ({ ...props }) => {
    const [itemPerPage, setItemPerPage] = useState(1000);
    const [currentPage, setCurrentPage] = useState(1);
    const [Statee, setStatee] = useState([]);

    const [load, setload] = useState(false);
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]

    const today = new Date();
    const tableRef = useRef(null);
    const tableRef1 = useRef(null);
    const [DataCount, setDataCount] = useState(0)
    const [generate1, setgenerate1] = useState(true);
    const [gen, setgen] = useState(0);
    const [loading, setloading] = useState(false);
    const [nextloading, setnextloading] = useState(false);
    const [loadmain, setloadmain] = useState(true);
    const [modal, setmodal] = useState(false);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        tomonth: sessionStorage.getItem("CurrentMonth") === null ? today.getMonth() + 1 : sessionStorage.getItem("CurrentMonth"),
        todummymonth: sessionStorage.getItem("CurrentMonth2") === null ? month1[today.getMonth() + 1] : month1[sessionStorage.getItem("CurrentMonth2")],
        toyear: sessionStorage.getItem("CurrentYear") === null ? today.getFullYear() : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 1,
        state: -1,
        
    });
    const paginate = (pageNumber) => {
        // Validate that a valid user or "All" option has been selected
        if (formData.state === -1) {
            alert("Please select a user or 'All' option to view data.");
            setnextloading(false);
            return;
        }

        setnextloading(true)
        setStatee([])
        var mainid = document.getElementById("datashow");
        mainid.scrollIntoView();
        //console.log(mainid);
      
        setCurrentPage(pageNumber)

        if (formData.state !== "0") { getdata3(pageNumber) } else { getdataAll(pageNumber) }
        
       
    };
    const [states, setstates] = useState("")
    const onInputChange = (e) => {
        var index = e.nativeEvent.target.selectedIndex;
         setstates(e.nativeEvent.target[index].text)
        setFormData({ ...formData, [e.target.name]: e.target.value });
        
    };
    
    const onInputChange2 = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };
    const onInputChange3 = (tomonth, toyear) => {
        setFormData({ ...formData, tomonth: tomonth, toyear: toyear });

    };
    const getdata3 = async (pageno) => {
        const sendData = {
            EmploymentRefId: Number(1),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth),
            Take: Number(itemPerPage),
            Skip: Number((pageno - 1) * itemPerPage)
        }
        
        // Validate UserId before sending request
        if (sendData.UserId < 1) {
            console.error('Invalid UserId:', sendData.UserId);
            setStatee([]);
            setload(true);
            setmodal(false);
            setnextloading(false);
            alert("Please select a state.");
            return;
        }

        console.log('Sending request with data:', sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES1MIS', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data && data.length > 0) {
                        setStatee(data)
                        if (data.length === 0) {
                            setmodal(false)
                        }
                    } else {
                        setStatee([])
                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)
                    
                  
                })
            .catch(error => {
                console.error('Error fetching data:', error);
                setStatee([]);
                setload(true);
                setmodal(false);
                setnextloading(false);
            })


    };

    const getdatacount = async () => {
        const sendData = {

            EmploymentRefId: Number(1),
            UserId: Number(formData.state),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/COUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data !== null && data !== undefined) {
                        setDataCount(data)
                    } else {
                        setDataCount(0)
                    }
                })
            .catch(error => {
                console.error('Error fetching count:', error);
                setDataCount(0);
            })


    };

    const getdatacountAll = async () => {
        const sendData = {

            EmploymentRefId: Number(1),
            UserId: Number(0),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth)
        }
        // console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ALLCOUNT', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data !== null && data !== undefined) {
                        setDataCount(data)
                    } else {
                        setDataCount(0)
                    }
                })
            .catch(error => {
                console.error('Error fetching all count:', error);
                setDataCount(0);
            })


    };

    const getdataAll = async (page) => {
        const sendData = {
            EmploymentRefId: Number(1),
            UserId: Number(0),
            MonthId: Number(formData.month),
            YearId: Number(formData.year),
            ToYearId: Number(formData.toyear),
            ToMonthId: Number(formData.tomonth),
            Take: Number(itemPerPage),
            Skip: Number((page - 1) * itemPerPage)
        }
        
        // Only add StateId if a specific state is selected (not "All")
        if (formData.state !== "0") {
            sendData.StateId = Number(formData.state);
        }
        
        console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/MIS/ES1MISAll', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => {
                if (!response.ok) throw new Error('Network response was not ok');
                return response.text().then(text => text ? JSON.parse(text) : null);
            })
            .then(
                data => {
                    if (data && data.length > 0) {
                        setStatee(data)
                        if (data.length === 0) {
                            setmodal(false)
                        }
                    } else {
                        setStatee([])
                    }
                    setload(true)
                    setmodal(false)
                    setTimeout(() => {
                        setnextloading(false)
                    }, 1000)
                })
            .catch(error => {
                console.error('Error fetching all data:', error);
                setStatee([]);
                setload(true);
                setmodal(false);
                setnextloading(false);
            })
    };

    const generate = async () => {
        // Validate that a valid user has been selected
        if (formData.state === -1) {
            alert("Please select a state.");
            return;
        }

        sessionStorage.setItem("NumberES1", 0)
        setgen(gen +1)
        setloadmain(false)
        setmodal(true)
        setload(false)
        getdata3(1)
        getdatacount()
        setgenerate1(false)

      

    }
    const generateAll = async () => {
        sessionStorage.setItem("NumberES1", 0)
        setgen(gen +1)
        setloadmain(false)
        setmodal(true)
        setload(false)
        getdatacountAll()
        getdataAll(1)
        setgenerate1(false)

      

    }

    const paginateData = Statee.slice(
        (currentPage - 1) * itemPerPage,
        currentPage * itemPerPage
    )

    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <BlockHead size="lg">

                            <BlockDes className="text-soft">
                        <Row >

                            <Col xl="3" md="3">
                                <td >
                                    <h5 style={{ color: '#798bff' }}>DGE Dashboard</h5>
                                </td>
                            </Col>
                            <Col xl="3" md="3" >
                                <label style={{ color: 'black', fontSize: 15 }}>  State :  <label style={{ fontWeight: 'bold' }}><OptionS catid="43" onInputChange={onInputChange} namemain="state" mainid="state" /></label></label>
                            </Col> 
                               <Col xl="3" md="3" >
                                <label style={{ color: 'black', fontSize: 15 }}>  From: <label style={{ fontWeight: 'bold' }}><OptionC  onInputChange={onInputChange2} year={formData.year} month={formData.month} /></label></label>
                             </Col>
                               <Col xl="3" md="3" >

                                <label style={{ color: 'black', fontSize: 15 }}>  To: <label style={{ fontWeight: 'bold' }}><OptionM  onInputChange={onInputChange3} year={formData.year} month={formData.month} /></label></label>
                                    </Col>
                                    <Col xl="3" md="3" >
                                        {formData.state !== String(0) ? <Button color="success" style={{ marginTop: 10 }} onClick={() => generate()}>Generate</Button> :
                                            <Button color="success" style={{ marginTop: 10 }} onClick={() => generateAll()}>Generate</Button>}


                                    </Col>
                           
                                </Row>
                            </BlockDes>
                        </BlockHead>
                                <hr />

                        <Modal isOpen={false} fullscreen="xl" size="xl" >
                            <ModalBody>
                                
                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br/>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <img src={loadspinner} alt="load" />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" onClick={() => window.location.reload()}>
                                    Stop Report
                                </Button>{' '}

                            </ModalFooter>
                        </Modal>

                            {generate1? <h3>Please Select State and Month to Generate Report!!</h3> : 
                            <>
                                {modal ? <div>
                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                        <Spinner size="xl" />
                                    </div>
                                </div> : null}
                                <div style={{ visibility: modal ? "hidden" :"visible" }}>
                            <Row>
                                <Col xl="3" md="3">
                                    <h4 style={{ marginBottom: 40 }}>Employment Report (ES1) </h4>
                                </Col>
                               <Col xl="3" md="3">
                                   
                                    </Col>
                                    {loadmain?
                                        <Col xl="3" md="3">

                                            <Button disabled style={{ float: "right", marginBottom: 10 }} color="danger" ><Icon class="icon ni ni-download"></Icon>Export Excel Abbreviation</Button>
                                           
                                        </Col> : <Col xl="3" md="3">
                                            <DownloadTableExcel
                                                filename="ES1 Report Abbreviation"
                                                sheet="users"
                                                currentTableRef={tableRef1.current}
                                            >
                                                <Button style={{ float: "right", marginBottom: 10 }} color="warning" ><Icon class="icon ni ni-download"></Icon>Export Excel Abbreviation</Button>
                                            </DownloadTableExcel>
                                        </Col>}
                                    {loadmain?
                                        <Col xl="3" md="3">
                                            <Button disabled style={{ float: "right" }} color="danger" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>

                                        </Col> :

                                        <Col xl="3" md="3">
                                            <DownloadTableExcel
                                                filename="ES1 Report"
                                                sheet="users"
                                                currentTableRef={tableRef.current}
                                            >
                                                <Button style={{ float: "right" }} color="info" ><Icon class="icon ni ni-download"></Icon>Export Excel</Button>
                                            </DownloadTableExcel>
                                        </Col>}
                               
                                </Row>

                                <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                            <table className="table table-orders" ref={tableRef1} style={{ borderCollapse: "separate", borderSpacing: 0, border: '1px solid black' }}>
                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0 }}>


                                    <tr> <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                        Description

                                    </th>
                                        <th rowSpan="2" style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                            Abbreviation

                                        </th>
                                        <br />
                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                            Description

                                        </th>
                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, verticalAlign: 'inherit' }} >
                                            Abbreviation

                                        </th>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Gender</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Jobseekers on the live Register at the end of previous month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >LR_PM</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Male</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >M</td>

                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", minWidth: "200px" }} >Total number of registration during the month ( includes regisration cards received on transfer + fresh registration + re-registration made during the month)</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold", alignItems: "center" }} >REG</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Female</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >F</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >No. of Jobseekers placed during the month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >P</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Transgender</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >TR</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Registration removed from Live Register during the month* ( includes regisrtation card removed from Live Register for reason other than Transfer to other exchanges and regisration cards transferred to other exchanges during the month)</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Rem</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Total</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >G_TOT</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Jobseekers remaining on the Live Register at the end of month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >LR_CM</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Category</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Submissions made during the month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SUB</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Caste</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SC</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Total vacancies notified during the month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >NOTIFIED</td>

                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Schedule Tribe</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >ST</td>
                                        <br />
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Vacancies filled during the month</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >FILLED</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >OBC</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Minorities Communities</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} ></td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Muslim</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >MUS</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Christians</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >CHR</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Sikhs</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >SIKH</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Budhists</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >BUDH</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Zoarastrians</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >ZO</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Total</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >MCO_TOT</td>
                                    </tr>
                                    <tr>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >Muslim</td>
                                        <td style={{ textAlign: 'center', border: '3px solid black', color: "black", padding: 10, fontWeight: "bold" }} >MUS</td>
                                    </tr>

                                </thead>

                            </table>

                                    </div>


                                    <div className="card-inner-group" style={{ border: '4px solid black', padding: 2 }}>
                                        <div style={{ height: window.innerHeight - 100, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                            <table className="table " ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0, counterReset: "Serial" }}>
                                                <div style={{ visibility: "hidden", height: 0, width: 0 }} className="table-responsive">
                                                    <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                        <tr>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                Form: ES1 Report

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                State: {states}

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                From Date: {month1[formData.month]} {formData.year}

                                                            </th>
                                                            <th colSpan="3" style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                                To Date: {month1[formData.tomonth]} {formData.toyear}

                                                            </th>
                                                        </tr>
                                                    </thead>
                                                </div>

                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>

                                                    <tr>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            S. No.

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            Year

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            Month
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            State

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            Employment Exchange

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            M_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            M_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            M_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            M-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            M_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            M_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            M_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            M_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            F_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            F_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            F_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            F-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            F_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            F_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            F_NOTIFIED
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            F_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            TR_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            TR_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            TR_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            TR-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            TR_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            TR_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            TR_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            TR_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            G_TOT_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            G_TOT_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            G_TOT_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            G_TOT-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            G_TOT_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            G_TOT_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            G_TOT_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            G_TOT_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SC_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SC_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SC_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SC-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SC_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SC_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SC_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SC_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ST_LR_PM
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ST_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ST_P
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ST-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ST_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ST_SUB
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ST_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ST_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            OBC_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            OBC_REG
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            OBC_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            OBC-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            OBC_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            OBC_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            OBC_NOTIFIED
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            OBC_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MUS_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MUS_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MUS_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MUS-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MUS_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MUS_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MUS_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MUS_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            CHR_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            CHR_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            CHR_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            CHR-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            CHR_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            CHR_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            CHR_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            CHR_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SIKH_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SIKH_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SIKH_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SIKH-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SIKH_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SIKH_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SIKH_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            SIKH_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            BUDH_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            BUDH_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            BUDH_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            BUDH-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            BUDH_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            BUDH_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            BUDH_NOTIFIED
                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            BUDH_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ZO_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ZO_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ZO_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ZO-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ZO_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ZO_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ZO_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            ZO_FILLED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MCO_TOT_LR_PM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MCO_TOT_REG

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MCO_TOT_P

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MCO_TOT-Rem

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MCO_TOT_LR_CM

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MCO_TOT_SUB

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MCO_TOT_NOTIFIED

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '3px solid black', color: "black", backgroundColor: 'orange', padding: 10, verticalAlign: 'inherit' }} >
                                                            MCO_TOT_FILLED

                                                        </th>


                                                    </tr>

                                                </thead>

                                                <tbody>
                                                    <td id="datashow" style={{ visibility: "hidden", height: 0, width: 0 }}></td>
                                                    {nextloading ? <div>
                                                        <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center" }}> Please wait while the report is loading......</h3><br />
                                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                            <Spinner size="xl" />
                                                        </div>
                                                    </div> : load ? (Statee.length !== 0 && nextloading === false ? Statee.map((details, index) =>
                                                        <tr>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>{(itemPerPage * (currentPage - 1)) + index + 1}</td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>      <b>  {details.yearId}</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>      <b>  {month1[details.monthId]}</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>      <b>  {details.state}</b></td>
                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                <b>  {details.center}</b>
                                                            </td>
                                                            {details.eSdata.map((data) =>
                                                                <>
                                                                    {data.parametersId === 4 ?
                                                                        <>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                            {data.jobseekersCol3 === null ? 0 : data.jobseekersCol3}


                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >

                                                                            {data.totalnumber4 === null ? 0 : data.totalnumber4}

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                            {data.noOfJobseekersCol5 === null ? 0 : data.noOfJobseekersCol5}


                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }} >
                                                                            {data.registrationremovedCol6 === null ? 0 : data.registrationremovedCol6}

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                            <label> {data.jobseekersremainingCol7 === null ? 0 : data.jobseekersremainingCol7}</label>
                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                            {data.submissionsMadeCol8 === null ? 0 : data.submissionsMadeCol8}

                                                                        </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                            {data.totalVacanciesCol9 === null ? 0 : data.totalVacanciesCol9}

                                                                        </td>
                                                                        <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                            {data.vacanciesFilled10 === null ? 0 : data.vacanciesFilled10}

                                                                        </td>
                                                                        
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                                {details.jobseekersCol3t1}
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                                {details.totalnumber4t1}
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                                {details.noOfJobseekersCol5t1}
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                                {details.registrationremovedCol6t1}
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                                {details.jobseekersremainingCol7t1}
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                                {details.submissionsMadeCol8t1}
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                                {details.totalVacanciesCol9t1}
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                                {details.vacanciesFilled10t1}
                                                                            </td>
                                                                        
                                                                        </>:
                                                                        <>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                {data.jobseekersCol3 === null ? 0 : data.jobseekersCol3}


                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 200 }} >

                                                                                {data.totalnumber4 === null ? 0 : data.totalnumber4}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                {data.noOfJobseekersCol5 === null ? 0 : data.noOfJobseekersCol5}


                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 300 }} >
                                                                                {data.registrationremovedCol6 === null ? 0 : data.registrationremovedCol6}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, minWidth: 150 }} >
                                                                                <label> {data.jobseekersremainingCol7 === null ? 0 : data.jobseekersremainingCol7}</label>
                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {data.submissionsMadeCol8 === null ? 0 : data.submissionsMadeCol8}

                                                                            </td>       <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {data.totalVacanciesCol9 === null ? 0 : data.totalVacanciesCol9}

                                                                            </td>
                                                                            <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                                                                                {data.vacanciesFilled10 === null ? 0 : data.vacanciesFilled10}

                                                                            </td>                                                                        

                                                                        </>
                                                                        }</>

                                                            )} 
                                                            <>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                    {details.jobseekersCol3t2}
                                                                </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                    {details.totalnumber4t2}
                                                                </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                    {details.noOfJobseekersCol5t2}
                                                                </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                    {details.registrationremovedCol6t2}
                                                                </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                    {details.jobseekersremainingCol7t2}
                                                                </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                    {details.submissionsMadeCol8t2}
                                                                </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                    {details.totalVacanciesCol9t2}
                                                                </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10, fontWeight: "bold" }}>
                                                                    {details.vacanciesFilled10t2}
                                                                </td>
                                                            </> 
                                                        </tr>
                                                    ) : <h3>No Data Found</h3>) : <Spinner color="success" />}



                                                </tbody>
                                            </table>

                                        </div>



                                    </div>


                                
                                   


                                </div>
                                {Statee.length > 0 && (
                                    <PaginationComponent
                                        noDown
                                        itemPerPage={itemPerPage}
                                        totalItems={DataCount}
                                        paginate={paginate}
                                        currentPage={currentPage}
                                        EmploymentRefId={1}
                                        UserId={formData.state}
                                        MonthId={formData.month}
                                        YearId={formData.year}
                                        ToYearId={formData.toyear}
                                        ToMonthId={formData.tomonth}
                                        setStatee={setStatee}
                                        setmodal={setmodal}
                                        setload={setload}
                                    />
                                )}
                            </>
                        }

                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default ES1DataReport;
